/**
 * Raised when the backend rejects a vault form submission with per-field
 * validation errors (code RV001). Carries the field → message map so the
 * form can highlight the exact fields, the same way client-side validation
 * does, instead of showing a generic submission error.
 */
export class VaultFormValidationError extends Error {
  readonly fields: Record<string, string>;

  constructor(message: string, fields: Record<string, string>) {
    super(message);
    this.name = "VaultFormValidationError";
    this.fields = fields;
  }
}
